<template>
  <div>
    {{$t("end_thanks_message")}}
  </div>
</template>

<script>
  export default {
    name: 'End',
  };
</script>

<style scoped>

</style>
